import React from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Factory.css";

function Factory() {
  const navigate = useNavigate(); // initialize navigation function

  const handleExploreClick = () => {
    navigate("/solution"); // navigate to /solution route
  };

  return (
    <div className="hero">
      
      <div className="hero-overlay">
        
        <h1>Your Energy Management<br />Solutions Partner</h1>
        <p>
          We are passionate about being part of your journey with energy
          management<br></br> solutions 
          that are ever–increasing in reliability,
          efficiency, safety and sustainability.
        </p>
        <button onClick={handleExploreClick}>Explore More</button>
      </div>
    </div>
  );
}

export default Factory;

